import { OktaAuthOptions } from "@okta/okta-auth-js";
import { environment } from "../../../environments/environment";

export const oktaConfig: OktaAuthOptions = {
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: window.location.origin + "/login",
  postLogoutRedirectUri: window.location.origin + "/",
  scopes: ["openid", "profile", "email"],
  pkce: true,
};
